import { render, staticRenderFns } from "./MiddleYouCanHostUpTo.vue?vue&type=template&id=15bcf7f0&scoped=true"
import script from "./MiddleYouCanHostUpTo.vue?vue&type=script&lang=js"
export * from "./MiddleYouCanHostUpTo.vue?vue&type=script&lang=js"
import style0 from "./MiddleYouCanHostUpTo.vue?vue&type=style&index=0&id=15bcf7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bcf7f0",
  null
  
)

export default component.exports